import React, { FC } from 'react';
import { Box, Alert } from '@mui/material';

type ProductionSchedulingAlertsProps = {
    errors: string[];
    warnings: string[];
};

const ProductionSchedulingAlerts: FC<ProductionSchedulingAlertsProps> = ({ errors, warnings }) => {
    return (
        <>
            {errors.map((msg) => (
                <Box mt={1} key={msg}>
                    <Alert severity="error">{msg}</Alert>
                </Box>
            ))}
            {warnings.map((msg) => (
                <Box mt={1} key={msg}>
                    <Alert severity="warning">{msg}</Alert>
                </Box>
            ))}
        </>
    );
};

export default ProductionSchedulingAlerts;
